var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52578 9.47367L1.69516 7.40595C1.36416 7.30575 1.35109 6.84193 1.67592 6.72325L16.0683 1.46486C16.0788 1.46075 16.0895 1.45716 16.1003 1.45408C16.3709 1.37514 16.6246 1.62882 16.5456 1.89946C16.5425 1.91022 16.5389 1.92086 16.5348 1.93136L11.2762 16.3238C11.1575 16.6486 10.6937 16.6355 10.5935 16.3045L8.52578 9.47367ZM14.7933 2.69724L2.93617 7.02936L8.7126 8.77796L14.7933 2.69724ZM9.22159 9.2872L15.3024 3.20639L10.9701 15.0635L9.22159 9.2872Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.fdcf7f906fc0425508802f9d7a4c8639.svg";
export { ForwardRef as ReactComponent };